const actions = {
  SET_STATE: 'user/SET_STATE',
  LOGIN: 'user/LOGIN',
  REGISTER: 'user/REGISTER',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  UPDATE_MY_PROFILE: 'user/UPDATE_MY_PROFILE',
  LOGOUT: 'user/LOGOUT',
}

export default actions
